import React, { forwardRef } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  min-height: 200px;
  
`;

interface PaginationWrapProps {
    children: React.ReactNode;
}

const PaginationWrap = forwardRef<HTMLDivElement, PaginationWrapProps>((props, ref) => {
    return <Wrapper ref={ref} {...props} />;
});

export default PaginationWrap;